module.exports = __webpack_public_path__ + "media/pt_pt_s2_Filipe.b94400f1.oga";